import { api } from './api';

/**
 * Wraps /api/v1/vouchers — the response envelope is unwrapped by the central api client.
 */

export const vouchersApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return;
      qs.append(k, v);
    });
    const q = qs.toString();
    return api.get(`/vouchers${q ? `?${q}` : ''}`);
  },

  get: (id) => api.get(`/vouchers/${id}`),

  nextNumber: (type, fiscalYearId) => {
    const qs = new URLSearchParams({ type });
    if (fiscalYearId) qs.append('fiscalYearId', fiscalYearId);
    return api.get(`/vouchers/next-number?${qs.toString()}`);
  },

  create: (payload) => api.post('/vouchers', payload),

  update: (id, payload) => api.patch(`/vouchers/${id}`, payload),

  updatePostedMeta: (id, payload) => api.patch(`/vouchers/${id}/meta`, payload),

  post: (id) => api.post(`/vouchers/${id}/post`),

  reverse: (id, payload = {}) => api.post(`/vouchers/${id}/reverse`, payload),

  remove: (id) => api.delete(`/vouchers/${id}`),
};
